module.exports = __webpack_public_path__ + "static/media/result_analysis.edc006cb.svg";